import makeCommandDispatcher from "web/core/apollo/makeCommandDispatcher";
import withProductRemovedTracking from "./withProductRemovedTracking";
import CartQuery from "theme/pages/Cart/CartQuery.gql";
import CartQtyQuery from "theme/layouts/Header/CartQtyQuery.gql";
import { compose, withHandlers, withProps } from "recompose";

const EnhanceRemoveItemCart = ({ RemoveCartItemMutation }) =>
  compose(
    withProductRemovedTracking(),
    makeCommandDispatcher({
      handleRemoveItem: (props) => (itemId) => ({
        options: {
          mutation: RemoveCartItemMutation,
          variables: { item_id: itemId },
          update: (store, { data }) => {
            const response = data.removeItemFromCart;
            if (response.success) {
              const cart = response.cart;

              store.writeQuery({
                query: CartQtyQuery,
                data: {
                  cart: {
                    id: cart.id,
                    items_qty: cart.items_qty,
                    __typename: cart.__typename,
                  },
                },
              });
              store.writeQuery({
                query: CartQuery,
                data: { cart: cart },
              });
            }
          },
          refetchQueries: ["CartQty"],
        },
        callback: props.onProductRemoved,
      }),
    }),
    withHandlers({
      removeItem: (props) => () => props.handleRemoveItem(props.item.item_id),
    }),
    withProps((props) => ({
      removeItemStatus: {
        commandPending: props.commandPending,
        hasMessage: props.hasMessage,
        message: props.message,
        success: props.success,
      },
    }))
  );

export default EnhanceRemoveItemCart;
